// App name: VISION PAGE PURPOSE
// Description:
//


const VisionPageApp = (function ($) {

  // variables
  let _flw = $('.flw'); //feature list
  let _stickyEl = $('.js-sticky');

  // init
  function init() {
    //
    positionIcon();
    triggerHref();
    hideContent();
  }

  //function name
  function positionIcon() {
    if(_flw.length) {
      _flw.find('.content-part .icon').each(function() {
        obj = $(this);
        var childPos = obj.offset();
        var parentPos = obj.parent().offset();
        var childOffset = {
          top: childPos.top - parentPos.top,
          left: childPos.left - parentPos.left
        }

        obj.css('top', childOffset.top);
      })
    }
  }

  function triggerHref() {
    var hash = window.location.hash;
    // hash = hash.substring(1);
    if(_stickyEl.length) {
      if(hash) {
        _stickyEl.find('a[href='+hash+']').trigger('click');
      }
    }
  }

  function hideContent() {
    var collapseEl = $('.post_custom.collapsed');
    if(collapseEl.length) {
      collapseEl.each(function() {
        var contentHint_1 = $(this).find('.post_custom__content_inner h5:first-child');
        var contentHint_2 = $(this).find('.post_custom__content_inner h5:nth-child(2)');
        var parentContentHint = $(this).find('.post_custom__content');
        if(contentHint_1.length) {
          var maxHeight_1 = contentHint_1.height();
          if (contentHint_2.length) {
            var maxHeight_2 = contentHint_2.height();
            var maxHeight = (maxHeight_1 + maxHeight_2) ;
            parentContentHint.css('max-height', maxHeight + 15);
          } else {
            parentContentHint.css('max-height', maxHeight_1);
          }
        }
      })
    }
  }

  return {
    init: init,
  };
})(jQuery);

jQuery('document').ready(function () {
  VisionPageApp.init();
});
